

exports.__esModule = true;
exports.$xoPageAddShippingPageComponent = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-address-components/src/add-address/directive');

require('components/xo-form-components/src/select-shipping-country/directive');

require('components/xo-validation/dist/directive');

require('components/xo-ui-components/src/tooltip/directive');

require('components/xo-ui-components/src/dropdown/directive');

require('components/xo-page-components/src/value-props/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddShippingPageComponent = exports.$xoPageAddShippingPageComponent = _squid.$Component.extend('$xoPageAddShippingPageComponent', {
    tag: 'xo-page-add-shipping-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state, $populate, // eslint-disable-line no-shadow
    $feature, $locale, $CheckoutAppDataModel) {

        $scope.token = $rootScope.token;
        $scope.locale = $locale;
        $scope.sidebar = false;
        $scope.callbacks = {
            done: function done() {
                $state.go('checkout.review');
            }
        };

        $populate($scope, {
            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');

            if (!$feature('supportBlockNonDomesticShipping', false, merchantCountry)) {
                $state.go('checkout.review');
            }
        });
    }
});

angular.value("$xoPageAddShippingPageComponent", $xoPageAddShippingPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-shipping/directive.js
// module id = ./pages/xo-add-shipping/directive.js
// module chunks = 1